export default "__VITE_ASSET__CZLiBhoO__"